import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getEmployerBenefits = ({ groupId, benefitPlanId }) =>
  call(websocketFetch, 'get_employer_benefits', {
    group_id: groupId,
    plan_ids: [benefitPlanId],
  });
